<template lang="pug">
.SwitchControl
  .SwitchControl-label
    slot
  .SwitchControl-button(
    :class='{ "SwitchControl-button--enabled": isEnabled }',
    @click='toggle',
    @mouseover='$emit("mouseover")',
    @mouseout='$emit("mouseout")'
  )
    .SwitchControl-circle
</template>

<script>
export default {
  name: 'switcher',
  model: {
    prop: 'isEnabled',
    event: 'toggle'
  },
  props: {
    isEnabled: Boolean,
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggle() {
      if (!this.isDisabled) {
        this.$emit('toggle', !this.isEnabled)
      }
    }
  }
}
</script>
<style lang="scss">
@import '~base';
#app .SwitchControl,
.Popup .SwitchControl {
  --primaryColor: #{$blue};
  --secondaryColor: #{$white3};
  --borderColor: #{$grey3};
  --inactiveBg: #{$grey7};
}

#app[data-theme='dark'] .SwitchControl,
.Popup[data-theme='dark'] .SwitchControl {
  --primaryColor: #{$blue};
  --secondaryColor: #{$grey3};
  --borderColor: #{$grey8};
  --inactiveBg: #{$grey8};
}
</style>
<style scoped lang="scss">
@import '~base';

.SwitchControl {
  display: flex;
  flex-direction: row;
  align-items: center;

  &-button {
    flex: 0 0 auto;
    height: 22px;
    width: calc(#{22px} * 2);
    border: 1px solid var(--borderColor);
    background: var(--inactiveBg);
    border-radius: 11px;
    transition: all 0.3s ease-in-out;
    cursor: pointer;

    &--enabled {
      background: var(--secondaryColor);
    }
  }

  &-circle {
    height: 16px;
    width: 16px;
    margin: 2px;
    border-radius: 50%;
    background: var(--secondaryColor);
    transition: all 0.3s ease-in-out;
  }

  &-button--enabled &-circle {
    background: var(--primaryColor);
    transform: translateX(22px);
  }

  &-label {
    flex: 1 1 auto;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Switcher.vue